import { TuiTooltipDirective } from '@clickbar/tailwindui-vue';
import { Link, createInertiaApp } from '@inertiajs/vue3';
import { useColorMode } from '@vueuse/core';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';

import { i18nVue, loadLanguageFile } from './i18n';
import sentryVuePlugin from '@/app/sentry';

import type { DefineComponent } from 'vue';

const appName = (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'Launchpad';
const lang = document.documentElement.lang;

useColorMode();

// eslint-disable-next-line unicorn/prefer-top-level-await
void loadLanguageFile(lang).then(() => {
  void createInertiaApp({
    title: (title: string) => `${title} - ${appName}`,
    progress: {
      color: '#4B5563',
    },

    resolve: (name: string) =>
      resolvePageComponent(
        `../pages/${name}.vue`,
        import.meta.glob<DefineComponent>('../pages/**/*.vue'),
      ),

    setup({ el, App, props, plugin }) {
      createApp({ render: () => h(App, props) })
        .use(plugin)
        .use(sentryVuePlugin)
        .use(i18nVue)
        .directive('tui-tooltip', TuiTooltipDirective)
        .component('inertia-link', Link)
        .component('InertiaLink', Link)
        .mount(el);
    },
  });
});
